import { render, staticRenderFns } from "./PedidosDetail.vue?vue&type=template&id=2c8350f6&"
import script from "./PedidosDetail.vue?vue&type=script&lang=ts&"
export * from "./PedidosDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports